export default __webpack_public_path__ + "static/media/186.8418fb44.jpg";